import { render, staticRenderFns } from "./ModuleYoutubeForm.vue?vue&type=template&id=84ef48aa&scoped=true"
import script from "./ModuleYoutubeForm.vue?vue&type=script&lang=js"
export * from "./ModuleYoutubeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ef48aa",
  null
  
)

export default component.exports